export default __webpack_public_path__ + "static/media/Oisin_Tohak_CV.28d16f17.pdf";